module.exports = __webpack_public_path__ + "img/lost-teddy-wide.67ad7b82.jpg";